export const creatorWorld = {
  title: "Creator World",
  subtitle: "Üdvözöllek a Creator világában!",
  welcomeMessage: "Itt minden elérhető, amit az előfizetésed tartalmaz",
  
  navigation: {
    products: "Termékek",
    events: "Események", 
    subscriptions: "Előfizetések",
    polls: "Szavazások",
    giveaways: "Nyereményjátékok",
    promoCodes: "Kuponkódok",
    challenges: "Kihívások",
    exclusiveContent: "Exkluzív tartalmak",
    profile: "Profilom"
  },

  gamification: {
    level: "Szint",
    points: "Pont",
    badges: "Kitüntetések",
    streak: "Sorozat",
    nextLevel: "Következő szint",
    pointsToNext: "pont a következő szintig",
    achievements: "Eredmények",
    leaderboard: "Ranglista"
  },

  stats: {
    totalPurchases: "Összes vásárlás",
    eventsAttended: "Részt vett események",
    pollsVoted: "Szavazatok leadva",
    challengesCompleted: "Kihívások teljesítve",
    contentViewed: "Megtekintett tartalmak",
    loyaltyPoints: "Hűségpontok"
  },

  products: {
    title: "Elérhető termékek és szolgáltatások",
    subtitle: "Fedezd fel az exkluzív kínálatot",
    buyNow: "Megveszem",
    learnMore: "Részletek",
    exclusive: "Exkluzív",
    newArrival: "Újdonság",
    popular: "Népszerű"
  },

  events: {
    title: "Események és találkozók",
    subtitle: "Csatlakozz a közösségi eseményekhez",
    upcoming: "Közelgő események",
    past: "Korábbi események",
    joinEvent: "Részvétel",
    eventFull: "Betelt",
    eventDate: "Időpont",
    eventLocation: "Helyszín",
    attendees: "Résztvevők"
  },

  polls: {
    title: "Aktív szavazások",
    subtitle: "Add meg a véleményedet",
    vote: "Szavazok",
    voted: "Szavaztál",
    results: "Eredmények",
    endsIn: "Lejár",
    totalVotes: "összes szavazat"
  },

  giveaways: {
    title: "Nyereményjátékok",
    subtitle: "Vegyél részt és nyerj fantasztikus díjakat",
    participate: "Részvétel",
    participated: "Részt veszel",
    prize: "Nyeremény",
    participants: "résztvevő",
    endsIn: "Lejár",
    winner: "Nyertes",
    drawDate: "Sorsolás dátuma"
  },

  promoCodes: {
    title: "Kuponkódjaim",
    subtitle: "Használd fel az exkluzív kedvezményeket",
    code: "Kód",
    discount: "Kedvezmény", 
    validUntil: "Érvényes",
    copyCode: "Kód másolása",
    copied: "Másolva!",
    useCode: "Felhasználom"
  },

  challenges: {
    title: "Kihívások",
    subtitle: "Teljesítsd a feladatokat és szerezz pontokat",
    daily: "Napi kihívások",
    weekly: "Heti kihívások",
    monthly: "Havi kihívások",
    completed: "Teljesítve",
    inProgress: "Folyamatban",
    notStarted: "Még nem kezdted el",
    reward: "Jutalom",
    complete: "Teljesít",
    progress: "Haladás"
  },

  exclusiveContent: {
    title: "Exkluzív tartalmak",
    subtitle: "Csak előfizetőknek elérhető tartalmak",
    watchNow: "Megtekintés",
    downloadNow: "Letöltés",
    newContent: "Új tartalom",
    duration: "Időtartam",
    size: "Méret",
    type: "Típus"
  },

  profile: {
    title: "Profilom",
    memberSince: "Tag vagyok",
    subscription: "Előfizetés",
    status: "Állapot",
    nextBilling: "Következő számlázás",
    manageSubscription: "Előfizetés kezelése",
    preferences: "Beállítások",
    notifications: "Értesítések",
    privacy: "Adatvédelem"
  },

  notifications: {
    newContent: "Új tartalom érkezett!",
    newEvent: "Új esemény lett hozzáadva!",
    newChallenge: "Új kihívás vár rád!",
    giveawayWinner: "Gratulálunk! Nyertél a nyereményjátékban!",
    levelUp: "Szint emelkedés! Elérted a(z) {level}. szintet!",
    badgeEarned: "Új kitüntetést szereztél!"
  },

  badges: {
    earlyBird: "Korai madár",
    socialButterfly: "Társasági lepke", 
    contentKing: "Tartalom király",
    challengeMaster: "Kihívás mester",
    loyalFan: "Hűséges rajongó",
    pollExpert: "Szavazás szakértő",
    eventAttendee: "Esemény látogató",
    firstPurchase: "Első vásárlás"
  }
};